export enum SelectorValue {
  SELECT_ALL_PAGES = "selectAllPages",
  DESELECT_ALL_PAGES = "deselectAllPages",
  SELECT_ITEMS = "selectItems",
  DESELECT_ITEMS = "deselectItems",
}
